import RootState from 'ducks/RootState';

export const getAdminMerchantIntegrationsState = (state: RootState) => state.integrations;
